<div class="tp-page tp-page--narrow">
  <tp-page-header title="Mi perfil" subtitle="Datos de tu cuenta de Tu Piscinero"></tp-page-header>

  @if (auth.user$ | async; as user) {
    <section class="tp-card profile" aria-label="Datos de la cuenta">
      @if (user.picture) {
        <img class="profile__avatar" [src]="user.picture" alt="" />
      } @else {
        <span class="profile__avatar profile__avatar--empty" aria-hidden="true"><mat-icon>person</mat-icon></span>
      }
      <dl class="profile__data">
        <div class="profile__row">
          <dt>Nombre</dt>
          <dd>{{ user.name || '—' }}</dd>
        </div>
        <div class="profile__row">
          <dt>Correo electrónico</dt>
          <dd>{{ user.email || '—' }}</dd>
        </div>
      </dl>
    </section>
  } @else {
    <section class="tp-card">
      <tp-empty-state icon="person_off" title="No hay una sesión activa" message="Iniciá sesión para ver los datos de tu cuenta."></tp-empty-state>
    </section>
  }
</div>
